/**
 * Quick Navigation Carousel
 * Initializes Glide.js carousel when quick navigation has more than 4 items.
 */

if (typeof window.Glide !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('[data-quick-navigation-carousel="true"]');

    carousels.forEach(function (carousel) {
      const slideCount = carousel.querySelectorAll('.glide__slide').length;

      if (slideCount > 4) {
        const glide = new Glide(carousel, {
          type: 'slider',
          startAt: 0,
          perView: 4,
          gap: 0,
          bound: true,
          peek: 64,
          breakpoints: {
            1100: {
              perView: 3,
            },
            768: {
              perView: 2,
            },
            600: {
              perView: 1,
            },
          },
        });

        glide.mount();
      }
    });
  });
} else {
  console.warn('Glide.js is not loaded. Quick Navigation Carousel will not be initialized.');
}
